import type { FaireProductEntity } from "../../entity_types/product";

export const p_8k6f8g7s88: FaireProductEntity = {
  token: "p_8k6f8g7s88",
  type: "product",
  name: "Ancestral Balm",
  brandToken: "b_t54jg48x6n",
  brandName: "Urban Farm Apothecary & Urban Farm Cosmetics",
  imageUrl:
    "https://cdn.faire.com/fastly/0add4540d90b90a2e9b966705ccea65f6ac332678f01aa925f7bf6f8118ac44b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6137888449ac60ded01c60edaeb3eec36302105c0984ca81a398719570e22acf.png",
    "https://cdn.faire.com/fastly/9b8bead5da9ee6913f1f757c64d620bbf5133aa126f17893e2838c61877e2b70.png",
  ],
  priceDollars: 17.7,
  description:
    "2 fl oz /4 fl oz glass jar\n\nThis gentle, nourishing balm is inspired by ancestral hunter gatherers from all over the globe.\n",
  tags: [],
  msrpDollars: 29.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:16.619Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
